// @ts-nocheck

/**
 * * `male` - Male
 * `female` - Female
 * `neutral` - Neutral
 */
export type PremadeCharacterGenderEnum =
  typeof PremadeCharacterGenderEnum[keyof typeof PremadeCharacterGenderEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PremadeCharacterGenderEnum = {
  male: "male",
  female: "female",
  neutral: "neutral",
} as const;
